import React, {Component} from 'react'

// import styles
import './cleanmodal.scss'

// import components
import Modal from '../../components/Modal'

class CleanModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      overflowHidden: false
    }
  }

  render () {
    return (
      <div className='clean__modal'>
        <Modal {...this.props} overflowHidden={this.state.overflowHidden}>
          {this.props.children}
        </Modal>
      </div>
    )
  }

}

export default CleanModal



// WEBPACK FOOTER //
// ./src/app/shared/modals/CleanModal/index.js